import { FieldDefinition } from "../../../../component/form/field-definition";

export const evaluatorBadgeAssignFieldDefinitions: FieldDefinition[] = [
    {
        id: "moduleId",
        name: "Module",
        type: "select",
        required: true,
        disabled: false,
        values: []
    }
]